import React from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import business from "../data/business.json";

const icons = {
  Instagram: InstagramIcon
};

const Footer = () => (
  <footer>
    <div className="container">
      <div className="row align-items-center">
        <div className="col-md-6">
          <span className="copyright">Copyright &copy; Bobbie Sue's {(new Date().getFullYear())}</span>
        </div>
        <div className="col-md-6 text-md-right">
          <ul className="list-inline social-buttons">
            {business.social.map(({ network, handle, url }) => {
              const Icon = icons[network];
              return (
                <li className="list-inline-item" key={network}>
                  <a href={url} target="_blank" rel="noopener noreferrer" aria-label={`Follow ${handle} on ${network} (opens in a new tab)`}>
                    <Icon aria-hidden="true" />
                  </a>
                </li>
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  </footer>
);

export default Footer;
